import { Grid, Typography } from '@material-ui/core';
import CustomerSelect from 'App/Vehicles/shared/CustomerSelect';
import LocationSelect from 'App/Vehicles/shared/LocationSelect';
import MaintenanceStatusSelect from 'App/Vehicles/shared/MaintenanceStatusSelect';
import React from 'react';

import maintenanceFiltersSchema, { MaintenanceFiltersSchema } from 'core/schemas/maintenanceFilters';
import {
  Form,
  FormSubmitHandler,
  InputField,
  SubmitButton,
} from 'Elements/Form';
import ResetButton from 'Elements/Form/ResetButton';
import SearchPane from 'Elements/SearchPane/SearchPane';

type Props = {
  onSubmit: FormSubmitHandler<MaintenanceFiltersSchema>;
};

export default function MaintenanceListFilters({ onSubmit }: Props) {
  return (
    <SearchPane>
      <Typography variant="h6">Suodattimet</Typography>
      <Form
        onSubmit={onSubmit}
        initialValues={{}}
        validationSchema={maintenanceFiltersSchema}
      >
        <MaintenanceStatusSelect name="status_id" />
        <LocationSelect name="location_id" />
        <CustomerSelect name="customer_id" />
        <InputField
          fullWidth
          name="search"
          variant="outlined"
          placeholder="Hae rek.no:lla tai tunnisteella"
          margin="normal"
          InputLabelProps={{ shrink: true }}
        ></InputField>

        <Grid container justify="flex-end" spacing={1}>
          <Grid item>
            <ResetButton variant="contained">Nollaa</ResetButton>
          </Grid>
          <Grid item>
            <SubmitButton variant="contained" color="secondary">
              Suodata
            </SubmitButton>
          </Grid>
        </Grid>
      </Form>
    </SearchPane>
  );
}
